import { useEffect, useState } from "react";
import styled from "styled-components";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import IconButton from "./IconButton";
import { CopyTooltipIcon } from "./CopyValue";

const SecretValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const SecretValue = ({
  redactedValue,
  fetchSecretValue,
}: {
  redactedValue: string;
  fetchSecretValue: () => Promise<string>;
}) => {
  const [revealedValue, setRevealedValue] = useState<string | null>(null);
  const [showRevealedValue, setShowRevealedValue] = useState<boolean>(false);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const copyTooltip = (
    <Tooltip style={{ position: "fixed" }}>
      <CopyTooltipIcon className="bi-clipboard-check-fill" />
      <span>Copied</span>
    </Tooltip>
  );

  useEffect(() => {
    if (showTooltip) {
      setTimeout(() => {
        setShowTooltip(false);
      }, 2000);
    }
  }, [showTooltip]);

  const getSecretValue = async () => {
    if (revealedValue) {
      return revealedValue;
    } else {
      const secretValue = await fetchSecretValue();
      setRevealedValue(secretValue);
      return secretValue;
    }
  };

  const revealSecretKey = async () => {
    await getSecretValue();
    setShowRevealedValue(true);
  };

  const copySecretKey = async () => {
    const secretValue = await getSecretValue();
    navigator.clipboard.writeText(secretValue);
    setShowTooltip(true);
  };

  const copyKeyButton = (
    <OverlayTrigger
      overlay={copyTooltip}
      show={showTooltip}
      placement="auto"
      rootClose
    >
      <div>
        <IconButton className={"bi-copy"} onClick={copySecretKey} />
      </div>
    </OverlayTrigger>
  );

  return (
    <SecretValueContainer>
      {showRevealedValue ? (
        <code>{revealedValue}</code>
      ) : (
        <>
          <code>{redactedValue}</code>
          <IconButton className={"bi-eye-fill"} onClick={revealSecretKey} />
        </>
      )}
      {copyKeyButton}
    </SecretValueContainer>
  );
};
